export default __webpack_public_path__ + "assets/c89c01463d06fb3b7c836e0c26aea72a.svg";